import React, { useContext, useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import "./Game_Statistics.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Game_Statistics_cards from "./Game_Statistics_cards/Game_Statistics_cards";
import No_data from "../Common/No_data/No_data";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../utils/context";
import { GetGameStatistic } from "../../features/games/color_prediction/Slice";
import { formatAmount } from "../../utils/common";

function Game_Statistics() {
  const [activeTab, setActiveTab] = useState("today");

  const statsData = {
    today: {
      totalBet: "₹0.00",
      totalLotteryBet: "₹0.00",
      numberOfBets: "0",
      winningAmount: "₹0.00",
    },
    yesterday: {
      totalBet: "₹120.00",
      totalLotteryBet: "₹100.00",
      numberOfBets: "5",
      winningAmount: "₹20.00",
    },
    week: {
      totalBet: "₹450.00",
      totalLotteryBet: "₹400.00",
      numberOfBets: "18",
      winningAmount: "₹50.00",
    },
    month: {
      totalBet: "₹1200.00",
      totalLotteryBet: "₹1000.00",
      numberOfBets: "45",
      winningAmount: "₹200.00",
    },
  };

  const data = statsData[activeTab];

  const dispatch = useDispatch();
  const { signin } = useContext(Context)

  const gameStatistic = useSelector((state) => state.games.color_prediction.statistic_data);

  console.log({ gameStatistic });

  useEffect(() => {
    if (signin)
      dispatch(GetGameStatistic({ filter: activeTab }))
  }, [dispatch, signin, activeTab])


  return (
    <section className="Game_Statistics">
        <Common_white_header headingText={"Game Statistics"} />
      <div className="container">


        {/* TABS */}

        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="stats_tabs"
        >
          <Tab eventKey="today" title="Today"></Tab>
          <Tab eventKey="yesterday" title="Yesterday"></Tab>
          <Tab eventKey="this_week" title="This Week"></Tab>
          <Tab eventKey="this_month" title="This Month"></Tab>
        </Tabs>

        {/* TOTAL BET CARD */}

        <div className="stats_card total_bet_card">
          <div className="total_amount">{formatAmount(gameStatistic.total_bet)}</div>
          <div className="total_label">Total bet</div>
        </div>

        {/* LOTTERY CARD */}
        {gameStatistic?.games?.length > 0
          ?
          gameStatistic?.games?.map((data) => (
            <Game_Statistics_cards
              name={data?.game_name}
              totalLotteryBet={formatAmount(data?.total_bet)}
              numberOfBets={data?.number_of_bets}
              winningAmount={formatAmount(data?.winning_amount)} />
          ))
          :
          < No_data />
        }

      </div>
    </section>
  );
}

export default Game_Statistics;